import React, { useState, useEffect } from "react";
import "./Form7.scss";
import { FiArrowRight, FiX, FiPlus } from "react-icons/fi";
import { connect } from "react-redux";
import { fileUpload } from "../../../store/media/actions";

const Form7 = (props) => {
  const [file, setFile] = useState('');
  const [image, setImage] = useState('');

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append('photo', file);
    formData.append('userId', props.userData.signupData.userId)
    props.fileUpload(formData);
    props.clicking(); 
  }

  const onFileChange = (event) => {
    const image = URL.createObjectURL(event.target.files[0])
    setFile(event.target.files[0]);
    setImage(image)
  };
  return (
    <div className="Form7 w-100">
      <div className="h1">My profile photos ...</div>
      <div className="note text-muted text-left">
        Choose at least 1 photo for profile
      </div>
      <div className="row">
        <div className="col-6">
          {/* <div className="image-upload">
            <input type="file" name="" id="img-1" />
            <label
              htmlFor="img-1"
              style={{
                backgroundImage:
                  "url(https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500)",
              }}
            >
              <div className="close">
                <FiX />
              </div>
            </label>
          </div> */}
        </div>
        <div className="col-6">
          <div className="d-flex justify-content-start align-items-start flex-column">
            <div className="image-upload">
              {
                image && <img className="sm" src={image} alt="selected-image" />
              }
              {/* <input type="file" name="" id="img-1" />
              <label
                className="sm"
                htmlFor="img-1"
                style={{
                  backgroundImage:
                    "url(https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500)",
                }}
              >
                <div className="close">
                  <FiX />
                </div>
              </label> */}
            </div>
            <div className="image-upload">
              <input 
                type="file"
                id="img-1" 
                onChange={onFileChange}
              />
              <label className="sm" htmlFor="img-1">
                <FiPlus />
                <div className="close d-none">
                  <FiX />
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="my-5"></div>
      <div className="d-flex justify-content-end align-items-center ">
        <button
          className="btn btn-primary rounded-3 btn-lg mt-4"
          onClick={()=> handleSubmit()}
        >
          Next
          <FiArrowRight className="ml-3" />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth,
  media: state.media
});

export default connect(mapStateToProps, {
  fileUpload
})(Form7);
